import LazyLoad from './lazyLoad';
import Accordion from './accordion';
const $ = jQuery.noConflict();

'use strict';
const SearchFacilities = {
	/*-------------------------------------------------------------------------------
        # Cache dom and strings
    -------------------------------------------------------------------------------*/

	$wrapper: $('.search-result-box'),


	/*-------------------------------------------------------------------------------
        # Initialize
    -------------------------------------------------------------------------------*/
	init: function() {

		this.search();
		this.searchSecond();
		this.loadingQuote();
	},

	search: function() {
		$('.js-search-facilities').on('keyup', (e) => {
			if (e.key === 'Enter' || e.keyCode === 13) {
				this.searchX();
			}
		});
	},

	searchSecond: function() {
		$('.search-bar__tab-search-icon').on('click', () => {
			this.searchX();
		});
	},


	searchX: function() {
		if ((location.pathname === '/') || (location.pathname === '/about/') || (location.pathname === '/careers/')) {
			window.location.href = window.location.href + '/search-result/';
			const s = $('.js-search-facilities').val();
			if (s) {
				localStorage.setItem('s', s);
			}
		}
		const s = $('.js-search-facilities').val();
		this.ajax(s);
	},

	loadingQuote: function() {
		$(() => {
			const local = localStorage.getItem('s');
			if(local) {
				$('.js-search-facilities').val(localStorage.getItem('s'));
				if(local) {
					this.ajax(local);
					localStorage.removeItem('s');
				}
			}
			if(!local) {
				this.ajax(local);
			}
		});
	},

	ajax: function(s){
		$.ajax({
			type: 'POST',
			// eslint-disable-next-line no-undef,camelcase
			url: citadel_corp_ajax.ajax_url,
			data: {
				action: 'searchFacilities',
				s: s
			},
			success: function(response) {
				$('.search-result-box').empty();
				$('.search-block__boxes-info').empty();
				$(response.htmlPosts).appendTo($('.search-result-box'));
				if(response.count > 0) {
					$('.search-block__boxes-info').append(response.count + ' Search Results').show();
				} else {
					$('.search-block__boxes-info').append('No Search Results').show();
				}
				$('.js-search-block-icon').each(function(e, el) {
					$(el).on('click', function() {
						const _self = $(this);
						if (_self.parent().hasClass('is-active')) {
							_self.parent().removeClass('is-active');
							_self.siblings('.js-search-block-hidden').slideUp();
						} else {
							_self.parent().addClass('is-active');
							_self.siblings('.js-search-block-hidden').slideDown();
							_self.parent().siblings().removeClass(Accordion.classActive).find('.js-search-block-hidden').slideUp();
						}
					});
				});
				LazyLoad.init();
			},
		});
	}
};

export default SearchFacilities;
